import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useEffect } from 'react'

import { resetAllModifiedDataByKey } from 'cng-common/features/form'

import { PARTNER_DATA_FORM_KEYS } from '../configs'

export const useResetFormData = () => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    return () => {
      Object.values(PARTNER_DATA_FORM_KEYS).forEach((formKey) => {
        dispatch(resetAllModifiedDataByKey(formKey))
      })
    }
  }, [dispatch])
}
